import classNames from 'classnames';
import { withFormsy } from 'formsy-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Select, { components } from 'react-select';

const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props} />
);

const CustomValueContainer = ({ children, ...props }) => (
  <components.ValueContainer {...props}>
    <components.Placeholder {...props} isFocused={props.isFocused}>
      {props.selectProps.placeholder}
    </components.Placeholder>
    {React.Children.map(children, (child) => (child && child.type !== components.Placeholder ? child : null))}
  </components.ValueContainer>
);

export class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);

    const { value } = this.props;
    if (value) {
      this.changeValue({ value });
    }
  }

  changeValue({ value }) {
    if (this.props.setValue) {
      this.props.setValue(value);
    }
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  }

  styles = {
    input: (provided) => ({ ...provided, margin: 0, padding: 0 }),
    placeholder: (provided, state) => ({
      ...provided,
      transform: null,
      top:
        state.hasValue || state.selectProps.inputValue ? '-50% !important' : 0,
      color:
        state.selectProps.inputValue || state.hasValue
          ? '#A3A2A1 !important'
          : '#383633',
    }),
  };

  render() {
    const {
      className,
      defaultValue,
      disabled,
      errorMessage,
      extraClass,
      id,
      isPristine,
      isValid,
      label = null,
      ariaLabel,
      multiple,
      name,
      options,
      showError,
      showRequired,
      value = '',
    } = this.props;

    return (
      <div
        className={classNames(
          'form-fancy',
          className,
          !isPristine && value && isValid ? 'valid' : 'invalid',
          {
            required: !isPristine && showRequired && !value,
            error: showError,
          },
        )}
      >
        <Select
          className={classNames(
            'react-select-container',
            { 'has-label': label },
            extraClass,
          )}
          classNamePrefix="react-select"
          id={id}
          isDisabled={disabled}
          multi={multiple}
          name={name}
          aria-label={ariaLabel || label}
          value={options.find((option) => option.value === value)}
          defaultValue={defaultValue}
          onChange={this.changeValue}
          options={options}
          ref={name}
          required={showRequired}
          components={{
            ValueContainer: CustomValueContainer,
            IndicatorSeparator: () => null,
            DropdownIndicator: (props) => (props.selectProps.menuIsOpen ? null : (
              <DropdownIndicator {...props} />
            )),
          }}
          styles={this.styles}
          placeholder={showError ? errorMessage : label}
        />
      </div>
    );
  }
}

Dropdown.propTypes = {
  className: PropTypes.string,
  defaultValue: PropTypes.any,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  extraClass: PropTypes.string,
  id: PropTypes.string,
  isValid: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  showError: PropTypes.bool,
  showRequired: PropTypes.bool,
  value: PropTypes.string,
};

Dropdown.defaultProps = {
  options: [],
};

const DropdownContainer = withFormsy(Dropdown);
DropdownContainer.displayName = 'DropdownContainer';

export default DropdownContainer;
